// extracted by mini-css-extract-plugin
export default {"titleWrapper":"BKSAw","title":"_1Nd4N","tooltip":"_2AFzd","titleIcon":"s1JPm","list":"_1Aq6X","noUserFullNameNotice":"_385Zw"};